import React from 'react';
import Snackbar from '@/components/Snackbar';
import ShipperList from './ShipperList';
import ShipperProfile from './ShipperProfile';
import { useShippersTab } from './hooks';

/**
 * The carrier account's Shippers tab: the partner list, and the selected shipper's profile.
 */
const ShippersTab = () => {
    const tab = useShippersTab();
    const { selectedShipper, notification, setNotification } = tab;

    return (
        <>
            <Snackbar open={notification.message} handleClose={() => setNotification({})} {...notification} />
            {selectedShipper ? (
                <ShipperProfile
                    partnership={selectedShipper}
                    setup={tab.getSetup(selectedShipper.shipper_id)}
                    notify={setNotification}
                />
            ) : (
                <ShipperList {...tab} />
            )}
        </>
    );
};

export default ShippersTab;
